// Event dispatched by cookie-compliance-management.
export const CCM_EVENT_NAME: string = 'ozCcmEvent';

export enum COOKIE_GROUPS {
    STRICTLY_NECESSARY = 'C0001',
    PERFORMANCE = 'C0002',
    FUNCTIONAL = 'C0003',
    TARGETING = 'C0004',
}
